import axios from 'axios';
import { BroadcastChannel } from 'broadcast-channel';

import { type Cart } from '../../shared/types';
import { type AddCartItemArgs } from '../types/types';

async function addItemToCartAtUrl({
    productId,
    quantity,
    valueVoucherPrice,
}: AddCartItemArgs): Promise<Cart> {
    const result = await axios.post<Cart>('/api/cart/add-item', {
        productId,
        quantity,
        valueVoucherPrice,
    });

    const syncCartBroadcastChannel = new BroadcastChannel('sync-cart-broadcast-channel', {
        webWorkerSupport: false,
    });

    // eslint-disable-next-line unicorn/require-post-message-target-origin
    await syncCartBroadcastChannel.postMessage({ cartVersion: result.data.cartVersion });

    await syncCartBroadcastChannel.close();

    return result.data;
}

export { addItemToCartAtUrl };
